export default __webpack_public_path__ + "static/media/design.6e3c6dfd.mp4";